import { Component } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation';
import { NavParams, Platform, ViewController } from 'ionic-angular';
import { ViewProvider } from '$providers/view';

declare var google;

@Component({
  selector: 'page-map',
  templateUrl: 'map.html',
})
export class MapPage {
  private inputMap: any;
  private map: any;
  private geocoder: any;

  private allowedBounds: any;
  private defaultLatLng: any;

  private currentPlace: any;

  constructor(navParams: NavParams, private geolocation: Geolocation, private platform: Platform,
    public viewCtrl: ViewController, private viewProvider: ViewProvider) {
    let neLat = navParams.get('neLat');
    let neLng = navParams.get('neLng');
    let swLat = navParams.get('swLat');
    let swLng = navParams.get('swLng');
    if (neLat && neLng && swLat && swLng) {
      this.allowedBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(neLat, neLng),
        new google.maps.LatLng(swLat, swLng)
      );
    }

    let defaultLat = navParams.get('defaultLat');
    let defaultLng = navParams.get('defaultLng');
    if (defaultLat && defaultLng) {
      this.defaultLatLng = new google.maps.LatLng(defaultLat, defaultLng);
    }

    this.currentPlace = navParams.get('place');
  }

  ionViewDidLoad() {
    if (this.currentPlace) {
      this.configureMap(this.currentPlace.geometry.location)
    } else {
      this.configureMap(this.defaultLatLng);
    }

    this.updateMap();
  }

  private configureMap(position) {
    const mapOptions = {
      zoom: 16,
      center: position,
      streetViewControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      scaleControl: false,
      zoomControl: true,
      fullscreenControl: false
    }

    this.map = new google.maps.Map(document.getElementById('map'), mapOptions);

    this.geocoder = new google.maps.Geocoder();

    this.configureAddressControl();
    this.configureAutoComplete();
    this.configureLocationControl();
    this.configureConfirmControl();
    this.configureMarker(position);

    this.map.addListener('dragend', () => this.updatePlaceWithMap());
  }

  private updateMap() {
    if (this.currentPlace) {
      let v = '';
      if (this.currentPlace.name && this.currentPlace.name != '') {
        v = this.currentPlace.name + " - ";
      }
      v += this.currentPlace.formatted_address;

      this.inputMap.value = v;
    } else {
      this.updatePlaceWithMap();
    }
  }

  private configureAddressControl() {
    let controlUIDiv = document.createElement('div');
    controlUIDiv.className = 'input-container';

    this.inputMap = document.createElement('input');
    if (this.platform.is('ios')) {
      this.inputMap.className = 'text-input text-input-ios input-map';
    } else {
      this.inputMap.className = 'text-input text-input-md input-map';
    }

    this.inputMap.type = 'text';
    this.inputMap.placeholder = 'Ex: Rua, Avenida...';
    this.inputMap.autocomplete = 'off';

    controlUIDiv.appendChild(this.inputMap);

    this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(controlUIDiv);

    this.inputMap.addEventListener('focus', () => this.inputMap.select());
  }

  private configureAutoComplete() {
    let autocompleteOptions = {
      types: ['geocode', 'establishment'],
      bounds: this.allowedBounds,
      strictBounds: true,
      componentRestrictions: { country: 'br' }
    };

    let autocomplete = new google.maps.places.Autocomplete(this.inputMap, autocompleteOptions);

    //adicionar o evento ao selecionar um endereço
    autocomplete.addListener('place_changed', () => {
      let place = autocomplete.getPlace();

      if (!place.geometry) {
        return;
      }
      this.currentPlace = place;

      this.map.setCenter(place.geometry.location);
    });
  }

  private configureLocationControl() {
    var controlDiv = document.createElement('div');

    var button = document.createElement('button');
    button.style.backgroundColor = '#fff';
    button.style.border = 'none';
    button.style.outline = 'none';
    button.style.width = '40px';
    button.style.height = '40px';
    button.style.borderRadius = '2px';
    button.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
    button.style.cursor = 'pointer';
    button.style.marginRight = '10px';
    button.style.padding = '0px';
    button.title = 'Localização Atual';
    button.className = 'gm-control-active';

    button.addEventListener('click', () => {
      this.geolocation.getCurrentPosition()
        .then((resp) => {
          this.map.setCenter(new google.maps.LatLng(resp.coords.latitude, resp.coords.longitude));
          this.updatePlaceWithMap();
        })
        .catch((error) => this.updatePlaceWithMap());
    });

    var img = document.createElement('img');
    img.src = 'data:image/png;base64,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';
    img.style.width = '26px';
    img.style.height = '26px';
    img.style.padding = '7px 7px 7px';
    button.appendChild(img);

    controlDiv.appendChild(button);
    this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
  }

  private configureConfirmControl(): any {
    let buttonMap = document.createElement('button');

    if (this.platform.is('ios')) {
      buttonMap.className = 'disable-hover button button-ios button-default button-default-ios button-block button-block-ios button-map';
    } else {
      buttonMap.className = 'disable-hover button button-md button-default button-default-md button-block button-block-md button-map';
    }

    buttonMap.innerHTML = 'Concluído';

    buttonMap.addEventListener('click', () => this.confirm());
    this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(buttonMap);

    return buttonMap;
  }

  private configureMarker(position) {
    let marker = new google.maps.Marker({ map: this.map, position: position });
    this.map.bindTo("center", marker, "position");
  }

  private updatePlaceWithMap() {
    let position = { location: this.map.getCenter() };

    this.geocoder.geocode(position, (results, status) => {
      if (status === 'OK') {
        if (results[1]) {
          this.setPlace(results[0]);
        } else {
          console.error('Não foi encontrado um endereço valido.');
        }
      } else {
        console.error('A geolocalização falhou Código do Erro:' + status);
      }
    });
  }

  private setPlace(place) {
    this.currentPlace = place;
    this.inputMap.value = place.formatted_address;
  }

  public confirm() {
    if (this.allowedBounds) {
      var x = this.currentPlace.geometry.location.lng();
      var y = this.currentPlace.geometry.location.lat();

      var maxX = this.allowedBounds.getNorthEast().lng();
      var maxY = this.allowedBounds.getNorthEast().lat();
      var minX = this.allowedBounds.getSouthWest().lng();
      var minY = this.allowedBounds.getSouthWest().lat();
      if ((x < minX || maxX < x) || (y < minY || maxY < y)) {
        this.viewProvider.showMessage('A localização selecionada não é válida.');
        return;
      }
    }

    this.viewCtrl.dismiss(this.currentPlace);
  }
}


// WEBPACK FOOTER //
// ./src/pages/map/map.ts